import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=68728a2d&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68728a2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68728a2d')) {
      api.createRecord('68728a2d', component.options)
    } else {
      api.reload('68728a2d', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=68728a2d&scoped=true&", function () {
      api.rerender('68728a2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/Message.vue"
export default component.exports